module.exports = __webpack_public_path__ + "img/Keep Control Box Black.d7e2df79.png";